import React from 'react';
import { useFormContext } from 'react-hook-form';
import BWAccordion from 'components/shared/BWAccordion';

const labels = { PAYMENT_DISCOUNT: 'Chiết khấu thanh toán', POST_VAT: 'Giá sau VAT', PRE_VAT: 'Giá trước VAT',
  ON_PAYMENT: 'Khi thanh toán nhà cung cấp', NO_VAT_ADJUSTMENT: 'Không điều chỉnh VAT' };
const display = value => labels[value] || value || 'Chưa khai báo';
export default function DiscountProgramProcurement() {
  const { watch } = useFormContext();
  const policy = watch('procurement');
  return <BWAccordion title='Điều kiện chiết khấu nhà cung cấp'>
    <dl className='dp-policy-grid'>
      {[['Loại chiết khấu', display(policy.accounting_treatment)], ['Cơ sở tính', display(policy.discount_basis)],
        ['Thời điểm ghi nhận', display(policy.recognition_timing)], ['Điều chỉnh VAT', display(policy.vat_adjustment)],
        ['Điều chỉnh giá vốn', policy.affects_inventory_cost == null ? 'Chưa khai báo' : policy.affects_inventory_cost ? 'Có' : 'Không']].map(([label, value]) =>
        <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}
    </dl>
    {policy.accounting_note && <p className='dp-policy-note'>{policy.accounting_note}</p>}
    <div className='bw_table_responsive bw_mt_2'><table className='bw_table'><thead><tr><th>Mức</th><th>Giá trị</th><th>Điều kiện đã khai báo</th></tr></thead><tbody>
      {policy.rules.map((rule, index) => <tr key={rule.id}><td>{index + 1}</td><td>{Number(rule.value).toLocaleString('vi-VN')}{Number(rule.value_type) === 2 ? '%' : ' đ'}</td><td>{rule.note}</td></tr>)}
    </tbody></table></div>
  </BWAccordion>;
}
